import React, { useState, useEffect } from 'react';
import { useSaleRoModel } from "../saleRoModel";
import { YhPrint } from "@/components/YhPrint";
import { saleRoService } from '../saleRoService';
import { IDetailList, ISaleRoDetail } from '../saleRoTypes';
import { formatNum, formatIntPoint, numberParseChina } from '@/utils/utils';
import moment from 'moment';
import { useDictModel } from '@/views/base/dict/dictModel';
import { YhPrintSa } from "@/components/YHPrintSa";

export type IMaintenanceAndItemType = {
    total: number
    discount: number
}
export function Print() {
    const initDesc = { total: 0, discount: 0 }
    const { print, setPrint, onPrinting, selectedRow } = useSaleRoModel();
    const [formVal, setFormVal] = useState<ISaleRoDetail>();
    const [goodsList, setGoodsList] = useState<IDetailList[]>([]);
    const { getTreeNodeOne } = useDictModel();
    const [maintenanceTotal, setMaintenanceTotal] = useState<IMaintenanceAndItemType>(initDesc);

    useEffect(() => {
        print && getPoDetailOne()
    }, [print])

    //获取一条数据
    const getPoDetailOne = async () => {
        let { retData } = await saleRoService.one(selectedRow.returnCode as string);
        let { details, ...formVal } = retData;
        let newMaintenanceTotal = { ...maintenanceTotal }

        let newDetails = details?.map((item, index) => {
            newMaintenanceTotal.total += Number(item.num) * Number(item.price);
            newMaintenanceTotal.discount = item.discountRate as number;
         return {
            ...item,
            No: index + 1,
            notAmount: Number(item.num) * Number(item.price)
        }})
        if (retData) {
            setGoodsList(newDetails as IDetailList[] ?? [])
            setFormVal(formVal)
            setMaintenanceTotal(newMaintenanceTotal)

        }
    };

    const columns = [
        {
            title: 'No',
            dataIndex: 'No',
        },
        {
            title: 'PART NO رقم القطع',
            dataIndex: 'materialCode',
        },
        {
            title: 'Description أسم القطع ',
            dataIndex: 'materialNameEn',
        },
        {
            title: 'Quantity كيمة  ',
            dataIndex: 'num',
        },
        {
            title: 'Unit price  SR أسعار ',
            dataIndex: 'price',
        },
        {
            title: ' Amount أجمالي ',
            dataIndex: 'notAmount',
        }
    ]
    //商品
    const columsAlb = [
        // {
        //     title: 'الاجمالي بعد الضريبة',
        //     dataIndex: 'total',
        //     // render:(text:any)=>''
        // },
        // {
        //     title: 'قيمة الضريبة',
        //     dataIndex: 'tax',
        //     // render:(text:any)=>''
        // },
        {
            title: 'الاجمالي',
            dataIndex: 'notAmount',
        },
        {
            title: 'سعر الوحدة',
            dataIndex: 'price',
        },
        {
            title: 'الكمية',
            dataIndex: 'num',
        },
        {
            title: 'الوحدة',
            dataIndex: 'unitNameEn',
        },
        {
            title: 'اسم الصنف',
            dataIndex: 'materialNameEn',
        },
        {
            title: 'رقم الصنف',
            dataIndex: 'materialCode',
        },
    ]
    const columsEn = [
        // {
        //     title: 'Total amount With',
        //     dataIndex: 'notAmount',
        //     render: (text: any, record: any) => formatNum(Number(text) * 1.15)
        // },
        // {
        //     title: 'Vat Amount',
        //     dataIndex: 'notAmount',
        //     render: (text: any, record: any) => formatNum(Number(text) * 0.15)
        // },          
        {
            title: 'Subtotal',
            dataIndex: 'notAmount',
        },
        {
            title: 'Unit Price',
            dataIndex: 'price',
        },
        {
            title: 'Quantity',
            dataIndex: 'num',
        },
        {
            title: 'Unit',
            dataIndex: 'unitNameEn',
        },
        {
            title: 'Item',
            dataIndex: 'materialNameEn',
        },
        {
            title: 'Item Code',
            dataIndex: 'materialCode',
        },
    ]
    //头部与底部展示
    const printShow = {
        header: [
            {
                fieldLabel: "Date:",
                fieldValue: moment(formVal?.createTime).format("YYYY/MM/DD"),
                fieldLabelAlb: 'التاريخ:'
            },
            {
                fieldLabel: "Customer Name:",
                fieldValue: formVal?.customerName,
                fieldLabelAlb: 'اسم العميل'
            },
            {
                fieldLabel: "Type:",
                fieldValue: getTreeNodeOne(formVal?.payType as string)[0]?.nameEn as string ?? '',
                fieldLabelAlb: 'نوع الفاتوره:'
            },
            {
                fieldLabel: "Invoice No:",
                fieldValue: `NOR${formVal?.returnCode?.slice(5)}`,
                fieldLabelAlb: 'رقم الفاتورة'
            },
            {
                fieldLabel: "Customer Vat No:",
                fieldValue: '',
                fieldLabelAlb: 'الرقم الضريبي للعميل',
                className: " border-bootom"
            },
        ],
        footer: [
            {
                fieldLabel: "Prepared",
                fieldValue: ""
            },
            {
                fieldLabel: "Prepared",
                fieldValue: ""
            },
            {
                fieldLabel: "Approved",
                fieldValue: ""
            },
        ],
        totalAmount: [
            // {
            //     fieldLabel: "SUBTOTAL اجمالي",
            //     fieldValue: Number(formVal?.amount)+Number(formVal?.favorableAmount),
            // },
            // {
            //     fieldLabel: "TOTAL اجمالي",
            //     fieldValue: formVal?.amount,
            // },
            // {
            //     fieldLabel: "VAT 15% الضريبة",
            //     fieldValue: Number(formVal?.taxation)
            // },
            // {
            //     fieldLabel: " NET TOTAL الصافي",
            //     fieldValue: Number(formVal?.totalAmount)
            // },
            {
                fieldLabel: "",
                fieldValue: "",
                empty: true,
                className: 'bd-none',
            },
            {
                fieldLabel: "Subtotal",
                fieldValue:  Number(formVal?.amount)+Number(formVal?.favorableAmount),
                fieldLabelAlb: "الاجمالي",
                className:'bd-none',                
            },
            {
                fieldLabel: "Discount",
                fieldValue: 0,
                suffix: "%",
                fieldLabelAlb: "نسبة الخصم",
                className:'bd-none',                
            },
            {
                fieldLabel: "Discount Amount",
                fieldValue: 0,
                fieldLabelAlb: "الخصم",
                className:'bd-none',                
            },
            {
                fieldLabel: "Net Total",
                fieldValue: Number(formVal?.amount),
                fieldLabelAlb: "الصافي",
                className:'bd-none',                
            },
            {
                fieldLabel: "Vat Amount 15 %",
                fieldValue: Number(formVal?.taxation),
                fieldLabelAlb:"الضريبة 15%",
                className:'bd-none',                
            },
            {
                fieldLabel: "Total With Vat",
                fieldValue:Number(formVal?.totalAmount),
                fieldLabelAlb: "الصافي بعد الضريبة",
                className:'bd-none',                
            },
        ]
    }
    const onCancel = () => {
        setPrint(false)
        setGoodsList([]);
        setFormVal({})
    }
    const onConfirm = async () => {
        let { id, returnCode } = selectedRow
        await onPrinting({ id, returnCode })
    }
    return (
        <YhPrintSa
            title=""
            type=""
            pageHeader="Return Invoice   فاتورة مرتجعات"
            visible={print}
            onClose={onCancel}
            onConfirm={onConfirm}
            columns={columns}
            dataSource={goodsList}
            printShow={printShow}
            formVal={`رقم الضريبة:301198769900003 شركة نور السيارات المحدودة
            تاريخ：${ moment(formVal?.createTime).format("DD/MM/YYYY HH:MM")}
            ضريبة القيمة المضافة：${+formatNum(Number(formVal?.taxation))}
            الإجمالي شاملاً ضريبة القيمة المضافة：${formatNum(Number(formVal?.totalAmount))}`}
            columsAlb={columsAlb}
            columsEn={columsEn}
        />
    );
}

export default Print;
